import { mapState, mapActions,mapGetters } from 'vuex'
import HttpFactory from '@/mixins/http.factory';
import customIndexRenderer from '@/components/zendesk-devops/index/customIndexRenderer.vue';
export default {
	mixins:[HttpFactory],
	data () {
		return {
			columnDefs:[],
			data:null,
			//auth only
			//baseUrl:config.baseUrl,
			//loading:false,
			isFormValidated:false,
			disableValidateBtn:true,
			//userMsg:{type:'info',list:[]},
			auth: {},
			isbtnClicked: false,
			showReportBugsbtn: false,
			localTesting: false,
			showReloadAppBtn:false
		}
	},
	created () {
		this.init();
	},
	computed:{
		//...mapGetters(['zendesk/getZendeskInfo']),
		//...mapState('zendesk',['zdMetadata']),
		...mapState('zendesk',['zendeskInfo']),
		...mapState('zdDevops',['appData'])
	},
	mounted() {

	},
	methods:{
		async init(){
			let _self = this;
			// window.addEventListener('message', (event) => {
			// 	if (event.data === 'oauth_success') {
			// 		location.reload(); // safest way
			// 	}
			// });

			await _self.getAppData();
			_self.fn().registerModalInstance();
		},
		async getAppData(){
			let _self=this;
			parentClient=null;
			_self.fn().clearMessage();
			_self.fn().showLoader(true);
			try{

				//await this.$store.dispatch('zendesk/getZendeskMetadata');
				await this.$store.dispatch('zendesk/getZendeskInfo')
				_self.handleReportBugsLinkFn();

				_self.auth.hdLoginUrl=_self.zendeskInfo.credentials.hdLoginUrl;
				_self.auth.hdEmail=_self.zendeskInfo.user.email;
				_self
				await this.$store.dispatch('zdDevops/getAppData',{auth:_self.zendeskInfo.credentials});
				_self.data = _self.appData;
			}
			catch(ex){
				console.log('inside catch of getAppData',ex);
				_self.commonErrorMsgDisp(ex);
			}
			_self.fn().showLoader(false);
			_self.setAppHeight();

		},
		handleReportBugsLinkFn() {
			let _self = this;
			let hideReportBugsFor = ['mandatamanagementdataserviceslimited','mandatamanagementdataserviceslimited1761660420','d3v-devopsintegration1'];//these are Zendesk subdomains where we need to hide Report Bugs link

			let subdomain = _self.getSubdomain(_self.zendeskInfo.credentials.hdLoginUrl);
			if (hideReportBugsFor.indexOf(subdomain) >= 0) {
				_self.showReportBugsbtn = false;
			} else {
				_self.showReportBugsbtn = true;
			}
		},
		//auth only
		getSubdomain(url) {
			// Remove protocol if present
			url = url.replace(/(^\w+:|^)\/\//, '');

			// Extract hostname (part before first slash)
			const hostname = url.split('/')[0];

			const parts = hostname.split('.');
			if (parts.length <= 2) return null; // no subdomain

			return parts[0]; // first subdomain only
		},
		checkForm: function (e,installBtnClick) {
            let _self=this;
            if(!installBtnClick){
                _self.disableValidateBtn=true;
                _self.isFormValidated=false;
            }

            _self.userMsg.list = [];
            _self.userMsg.type='danger';
            if (_self.auth.hdLoginUrl && _self.auth.hdToken
            && _self.auth.devOpsUrl && _self.auth.devOpsToken) {
                return true;
            }

            if (!_self.auth.hdLoginUrl) {
                _self.userMsg.list.push('Zendesk Url is required.');
            } else if(!_self.validUrl(_self.auth.hdLoginUrl)){
                _self.userMsg.list.push('Zendesk Url is invalid.');
            }
            if (!_self.auth.hdToken) {
                _self.userMsg.list.push('Zendesk Token is  required.');
            }
			if (!_self.auth.hdEmail) {
                _self.userMsg.list.push('Zendesk Email is  required.');
            } else if(!_self.validEmail(_self.auth.hdEmail)){
				_self.userMsg.list.push('Zendesk Email is  invalid.');
			}
            if (!_self.auth.devOpsUrl) {
                _self.userMsg.list.push('Azure DevOps Url is  required.');
            }else if(!_self.validUrl(_self.auth.devOpsUrl)){
                _self.userMsg.list.push('Azure DevOps Url is invalid.');
            }
            if (!_self.auth.devOpsToken) {
                _self.userMsg.list.push('Azure DevOps Token is required.');
            }
            if(e){
                e.preventDefault();
            }
        },
        authenticate(e,cb){
            let _self=this;
            if(!_self.checkForm(e)) return;
            _self.loading=true;
			_self.auth.appId=_self.zendeskInfo.credentials.appId;
			_self.auth.installationId=_self.zendeskInfo.credentials.installationId;
            var options = {
                method: 'POST',
                body: _self.auth,
                json: true,
                //url: _self.baseUrl+'authenticate',
				url:'authenticate',
                headers: {'Content-Type': 'application/json'}
            };
            _self.userMsg.type='danger';
            _self.userMsg.list=[];
            _self.isFormValidated=false;
            _self.post(options.url,options.body).then(function(response) {
                _self.loading=false;
                if(cb) cb(null,response);
                if(response.data.Data && response.data.Success){
                    _self.userMsg.type='info';
                    _self.isFormValidated=true;
                    _self.userMsg.list.push('App validated successfully.');
                    _self.init();
					//window.location.reload();
                }else{
                    _self.userMsg.list.push('App validation failed.');
                    if(response && response.data && response.data.Errors && response.data.Errors.length>0){
                        for(var i=0;i<response.data.Errors.length;i++){
                            _self.userMsg.list.push(response.data.Errors[i].Message);
                        }
                    }
                }
            },function(error){
                _self.loading=false;
                _self.userMsg.list.push('App validation failed.');
                if(error && error.response && error.response.Errors && error.response.Errors.length>0){
                    for(var i=0;i<error.response.Errors.length;i++){
                        _self.userMsg.list.push(error.response.Errors[i].Message);
                    }
                }
                if(cb) cb(error);
            });
        },
		validateEmpty:function(txt) {
            if (!txt || txt.trim() === '') {
                return false;
            } else {
                return true;
            }
        },
        validUrl: function (value) {
            return /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i.test(value);
        },
        validEmail: function (email) {
            var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
		},
		reloadAppFn() {
			//const _self = this;
			window.location.reload();
		},
		//begins old methos auth ends
		authenticate_modal_old(){
			let _self=this;
			var size = { width: '80vw', height: '70vh' };
			let zdTicketId = _self.zendeskInfo.ticket.id;
			let action=`authenticate`;
			if(_self.appData &&_self.appData.userInfo && _self.appData.userInfo.id){
				action+=`/${_self.appData.userInfo.id}/${encodeURIComponent(_self.appData.userInfo.devOpsUrl)}`
			}
			_self.fn().create_zendesk_modal(action,size,null,null,null,function(){
				_self.getAppData();
			});
		},
		authenticateDevOps_modal(){
			let _self = this;
			_self.showReloadAppBtn = false;
			var size = { width: '80vw', height: '70vh' };
			let zdTicketId = _self.zendeskInfo.ticket.id;
			let action=`authenticate-devops`;
			if(_self.appData &&_self.appData.userInfo && _self.appData.userInfo.id){
				action+=`/${_self.appData.userInfo.id}/${encodeURIComponent(_self.appData.userInfo.devOpsUrl)}`
			}
			_self.fn().create_zendesk_modal(action,size,null,null,null,function(){
				//_self.getAppData();
				_self.loading=true;
				setTimeout(function () {
					_self.loading=false;
					_self.showReloadAppBtn = true;
				}, 1000);
			});
    },

		//ends old methos auth ends
		//begins new methods for auth
		authenticate_modal(){//auth ends
      let _self = this;

      let isApiTokenAuthAllowed = false;
      isApiTokenAuthAllowed = _self.fn().isApiTokenAuthAllowed(_self.zendeskInfo.credentials.appId, _self.zendeskInfo.credentials.installationId);//temp remove after completed removed by Zendesk.

      if (isApiTokenAuthAllowed) {
        _self.authenticate_modal_old();///old API token based auth flow in case the installation is allowed for API token based auth
      } else {
        _self.authenticateDevOps_modal();
      }

			//_self.authenticate_modal_old();///as oauth is not approved yet
			//_self.authenticateDevOps_modal();
			//_self.authenticate_outh2_modal();
			//_self.authenticate_token_modal();

		},
		authenticate_outh2_modal() {
			// https://developer.monday.com/apps/docs/mondayexecute
			let _self=this;
			var size = { width: '50vw', height: '70vh' };

			let hdTicketId = _self.zendeskInfo.ticket.id;

			let action = `authenticate_outh2/${_self.zendeskInfo.credentials.appId}/${_self.zendeskInfo.credentials.installationId}/${_self.data.zendeskAuthConfig.client_id}/${hdTicketId}`;

			if(_self.appData &&_self.appData.userInfo && _self.appData.userInfo.id){
				action+=`/${_self.appData.userInfo.id}/${encodeURIComponent(_self.appData.userInfo.devOpsUrl)}`
			}
			// if (_self.data && (_self.data.message == 'Unauthorized access...' || _self.data.message == 'Your API tokens expired/invalid. Please Re-Authenticate.')) {
			// 	action += `?client_id=${_self.data.zendeskAuthConfig.client_id}`;
			// }

			action += `?redirect_uri=${_self.data.zendeskAuthConfig.redirect_uri}`;

			_self.fn().create_zendesk_modal(action, size, null, null, null, function () {
				_self.fn().clearMessage();
				_self.fn().showLoader(true);
				document.location.reload();
			 	//_self.getAppData();
			});
		},
		authenticate_token_modal() {
			// https://developer.monday.com/apps/docs/mondayexecute
			let _self=this;
			var size = { width: '80vw', height: '70vh' };

			let mdItemId = _self.mondayInfo.item.id;
			let action = `authenticate_token/${_self.mondayInfo.credentials.appId}/${_self.mondayInfo.credentials.installationId}`;

			if(_self.appData &&_self.appData.userInfo && _self.appData.userInfo.id){
				action+=`/${_self.mondayInfo.item.board.id}/${mdItemId}/${_self.appData.userInfo.id}/${encodeURIComponent(_self.appData.userInfo.devOpsUrl)}`
			}
			// if (_self.data && (_self.data.message == 'Unauthorized access...' || _self.data.message == 'Your API tokens expired/invalid. Please Re-Authenticate.')) {
			// 	action += `/${_self.data.mondayConfig.client_id}`;
			// }
			_self.fn().create_monday_modal(action, size, null, null, null, function () {
				_self.fn().clearMessage();
				_self.fn().showLoader(true);
				document.location.reload();
				//_self.getAppData();
			});
		},
		//ends new methods for auth
		configure(){
			let _self=this;
			var size = { width: '80vw', height: '70vh' };
			let zdTicketId = _self.zendeskInfo.ticket.id;
			_self.isbtnClicked = true;
			_self.fn().create_zendesk_modal(`configure/${zdTicketId}`, size, null, null, null, function () {
				if (_self.isbtnClicked == true) {
					_self.isbtnClicked = false;
					_self.getAppData();
				}
			});
		},
		configureApp(){
			let _self=this;
			var size = { width: '80vw', height: '70vh' };
			let zdTicketId = _self.zendeskInfo.ticket.id;
			_self.isbtnClicked = true;
			_self.fn().create_zendesk_modal(`configure-app/${zdTicketId}`, size, null, null, null, function () {
				if (_self.isbtnClicked == true) {
					_self.isbtnClicked = false;
					_self.getAppData();
				}
			});
		},
		docsRedirect(){
			let redirectUrl='https://devopsintegration.io/docs/zendesk-devops';
			window.location.replace(redirectUrl);
		},
		createWorkItem(){
			let _self=this;
			var size={ width: '80vw',height: '100vh'};
			let cPath='';
			//console.log('data is',_self.data);
			console.log('Cust ADO Org Is ',_self.fn().getDevOpsOrg(_self.appData.userInfo.devOpsUrl));
			if(_self.data && _self.data.userInfo){
				switch(_self.fn().getDevOpsOrg(_self.appData.userInfo.devOpsUrl)){
					case 'devopsintegrationio1':
						cPath = 'custom/devopsintegrationio/';
						//cPath='custom/payoneer/'; //infosysmanager@payoneer.com
					break;
					case 'powermatrix':
						cPath='custom/powermatrix/';
					break;
					case 'limeade':
						cPath='custom/limeade/';
					break;
					case 'NovoPathLLC':
						cPath='custom/novopathllc/';
					break;
					case 'oncologyanalytics':
						cPath='custom/oncologyanalytics/';
					break;
					case 'kneatorg':
						cPath='custom/kneatorg/';
					break;
					case 'castlequick12':
						cPath='custom/castlequick/';
					break;
					case 'engagetfs'://'engagetfs':
						cPath='custom/engagetfs/';
					break;
					case 'hubb'://notify, inxpo
						cPath='custom/hubb/';
					break;
					case 'EPMPartners':
						cPath='custom/epmpartners/';
					break;
					case 'DataLinkSoftware':
						cPath='custom/datalinksoftware/';
					break;
					case 'nautilus-org':
						cPath='custom/nautilus-org/';
					break;
					case 'UWA-DEV':
						cPath='custom/uwa-dev/';
						break;
					case '123CE':
						cPath='custom/upkalidea/';
						break;
					case 'Personify360.Tickets':
						cPath='custom/personifycorp/';
						break;
					case 'smartr365':
						cPath='custom/smartr365/';
						break;
					case 'loc-devops':
						cPath='custom/loc-devops/';
						break;
					case 'toyotavso':
						cPath='custom/toyotavso/';
						break;
					case 'applieddatacorp':
						cPath='custom/upshop/';
						break;
					case 'dnvimatis':
						cPath='custom/dnvimatis/';
						break;
					case 'SCS-UK':
						cPath='custom/tvsscs/';
						break;
					case 'echo-project':
						cPath='custom/echo-project/';//https://rayzoneg.zendesk.com //https://echo-project.visualstudio.com
						break;
					case 'montagetalent':
						cPath='custom/montagetalent/'; //https://hvinterviews.zendesk.com
						break;
					case 'intelligentcomms':
						cPath='custom/intelligentcomms/'; //https://calero.zendesk.com
						break;
					case 'tritrials':
						cPath='custom/tritrials/'; //paul.swift@tritrials.com
						break;
					case 'dealer-fx':
						cPath='custom/dealer-fx/'; //james_paulsen@dealer-fx.com
						break;
					case 'ehn-code':
						cPath='custom/liviniti/'; //andrew.eden@liviniti.com
						break;
					case 'accreditbizops':
						cPath='custom/accreditbizops/'; //r.morley@accredit-solutions.com
						break;
					case 'iqul':
						cPath='custom/iqul/'; //r.morley@accredit-solutions.com
						break;
					case 'rivalitinc':
						cPath='custom/rivalitinc/'; //abdallahmoudarres@rivalit.com
						break;
					case 'Payoneer':
						if ((_self.data.userInfo.id == 1554 && _self.data.userInfo.hdLoginUrl == 'https://payoneer--mis.zendesk.com')
							|| (_self.data.userInfo.hdLoginUrl == 'https://d3v-devopsintegration.zendesk.com' && _self.localTesting==true)) {
							cPath = 'custom/payoneer/'; //infosysmanager@payoneer.com
						}
						break;
					case 'MandataGroup':
						cPath='custom/mandatagroup/'; //ahigginson@mandata.co.uk
						break;
					case 'eurekais':
						cPath='custom/eurekais/'; //ahigginson@mandata.co.uk
            break;
          case 'rizepointcoredevops1':
						cPath='custom/rizepointcoredevops/'; //rizepointcoredevops  jason.williams@franconnect.com
            break;
          case 'par-excellence-systems-inc':
						cPath='custom/par-excellence-systems-inc/'; //jpresley@parexcellence.com
            break;
          case 'complexcaredev':
						cPath='custom/complexcaredev/'; //jason.spahn@complexcaresolutions.com
						break;
				}
			}
			let zdTicketId = _self.zendeskInfo.ticket.id;
			_self.isbtnClicked = true;
			_self.fn().create_zendesk_modal(cPath + 'create-work-item/' + zdTicketId, size, null, null, null, function () {
				if (_self.isbtnClicked == true) {
					_self.isbtnClicked = false;
					_self.getAppData();
				}
			});
		},
		searchWorkItem(){
			const _self=this;
			var size = { width: '80vw', height: '80vh' };
			let zdTicketId = _self.zendeskInfo.ticket.id;
			_self.isbtnClicked = true;
			_self.fn().create_zendesk_modal(`search-work-item/${zdTicketId}`, size, null, null, null, function () {
				if (_self.isbtnClicked == true) {
					_self.isbtnClicked = false;
					_self.getAppData();
				}
			});
		},
		notifyWorkItem(){
			let _self=this;
			var size = { width: '50vw', height: '80vh' };
			let zdTicketId = _self.zendeskInfo.ticket.id;
			_self.isbtnClicked = true;
			_self.fn().create_zendesk_modal(`notify-work-item/${zdTicketId}`, size, null, null, null, function () {
				if (_self.isbtnClicked == true) {
					_self.isbtnClicked = false;
					_self.getAppData();
				}
			});
		},
		linkWorkItem(){
			let _self=this;
			var size = { width: '40vw', height: '55vh' };
			let zdTicketId = _self.zendeskInfo.ticket.id;
			_self.isbtnClicked = true;
			_self.fn().create_zendesk_modal(`link-work-item/${zdTicketId}`, size, null, null, null, function () {
				if (_self.isbtnClicked == true) {
					_self.isbtnClicked = false;
					_self.getAppData();
				}
			});
		},
		linkedTickets(){
			let _self = this;
			var size = { width: '80vw', height: '60vh' };
			let zdTicketId = _self.zendeskInfo.ticket.id;
			let cPath='';
			if(_self.data && _self.data.userInfo){
				switch(_self.fn().getDevOpsOrg(_self.appData.userInfo.devOpsUrl)){
					case 'devopsintegrationio1':
						cPath='custom/dmatter/';
					break;
          case 'kneatorg':
            cPath = 'custom/kneatorg/';
            break;
          case 'dealer-fx':
						cPath='custom/dealer-fx/';
					break;
				}
			}
			_self.isbtnClicked = true;
			_self.fn().create_zendesk_modal(cPath + `linked-tickets/${zdTicketId}`, size, null, null, null, function () {
				if (_self.isbtnClicked == true) {
					_self.isbtnClicked = false;
					_self.getAppData();
				}
			});
		},
		enableSyncing(){
			let _self=this;
			//var size={ width: '50vw',height: '50vh'};
			var size={ width: '80vw',height: '100vh'};
			_self.fn().create_zendesk_modal('enable-syncing',size,null,null,null,function(){
				//_self.getAppData();
			});
		},
		workItemLog(linkData){
			let _self=this;
			var size = { width: '80vw', height: '100vh' };
			let zdTicketId = _self.zendeskInfo.ticket.id;
			let cPath='';
			//console.log('Cust ADO Org Is ',_self.fn().getDevOpsOrg(_self.appData.userInfo.devOpsUrl));
			if(_self.data && _self.data.userInfo){
				switch(_self.fn().getDevOpsOrg(_self.appData.userInfo.devOpsUrl)){
					case 'devopsintegrationio1':
						cPath = 'custom/devopsintegrationio/';
						cPath='custom/personifycorp/';
					break;
					case 'Personify360.Tickets':
						cPath='custom/personifycorp/';
						break;
				}
			}
			_self.zendeskInfo.linkData = linkData;

			let triggerInstance=`work-item-log-dialog_zd${linkData.hdTicketId}_wd${linkData.workItemId}`;
			let action = cPath + `work-item-log/${zdTicketId}?hdTicketId=${linkData.hdTicketId}&workItemId=${linkData.workItemId}&devOpsTenant=${linkData.devOpsTenant}`;
			_self.isbtnClicked = true;
			_self.fn().create_zendesk_modal(action, size, triggerInstance, null, _self.zendeskInfo, function () {
				if (_self.isbtnClicked == true) {
					_self.isbtnClicked = false;
					_self.getAppData();
				}
			});
		},
		resetCacheConfirm(){
			let _self=this;
			let linkData={hdTicketId:_self.zendeskInfo.ticket.id};
			var size={ width: '30vw',height: '8vw'};
			_self.zendeskInfo.linkData=linkData;
			_self.zendeskInfo.msg=`Do you want to reset the cache?`
			let triggerInstance=`confirm-dialog_zd${linkData.hdTicketId}_cacheReset`;
			let cbInstance=`remove-confirm-dialog_zd${linkData.hdTicketId}_cacheReset`;
			let action = `confirm-dialog?hdTicketId=${linkData.hdTicketId}&cacheReset=${linkData.hdTicketId}`;
			_self.isbtnClicked = true;

			_self.fn().create_zendesk_modal(action, size, triggerInstance, cbInstance, _self.zendeskInfo, function (response) {
				if (_self.isbtnClicked == true) {
					_self.isbtnClicked = false;
					if (response.Success && response.type == 'confirmed') {
						_self.resetCache(linkData, _self.getAppData);
					} else {
						_self.getAppData();
					}
				}

			});
		},
		resetCache(linkData,cb){
			let _self=this;
			_self.fn().clearMessage();
			let data={
				auth:_self.zendeskInfo.credentials
			};
			let url=`reset/cache/${linkData.hdTicketId}`;
			_self.post(url,data).then(response=>{
				_self.fn().showLoader(false);
				if(cb) cb(response.data);
			}).catch(error=>{
				_self.commonErrorMsgDisp(error);
			});
		},
		removeConfirm(linkData){
			let _self=this;
			var size = { width: '30vw', height: '8vw' };
			let zdTicketId = _self.zendeskInfo.ticket.id;
			_self.zendeskInfo.linkData=linkData;
			_self.zendeskInfo.msg=`Do you want to unlink Work item: #${linkData.workItemId}?`
			let triggerInstance=`confirm-dialog_zd${linkData.hdTicketId}_wd${linkData.workItemId}`;
			let cbInstance=`remove-confirm-dialog_zd${linkData.hdTicketId}_wd${linkData.workItemId}`;
			let action=`confirm-dialog/${zdTicketId}?hdTicketId=${linkData.hdTicketId}&workItemId=${linkData.workItemId}&devOpsTenant=${linkData.devOpsTenant}`;
			_self.fn().create_zendesk_modal(action,size,triggerInstance,cbInstance,_self.zendeskInfo,function(response){
				if(response.Success && response.type=='confirmed'){
					_self.unlinkWorkItem(linkData,_self.getAppData);
				}else{
					_self.getAppData();
				}

			});
		},
		unlinkWorkItem(linkData,cb){
			let _self=this;
			_self.fn().clearMessage();
			let data={
				auth: _self.zendeskInfo.credentials,
				user:_self.zendeskInfo.user
			};
			let url;
			if(linkData.devOpsTenant)
				url = `zendesk/unlink/${linkData.hdTicketId}/${linkData.workItemId}/${linkData.devOpsTenant}`;
			else
				url=`zendesk/unlink/${linkData.hdTicketId}/${linkData.workItemId}`;
			_self.post(url,data).then(response=>{
				_self.fn().showLoader(false);
				if(cb) cb(response.data);
			}).catch(error=>{
				_self.commonErrorMsgDisp(error);
			});
		},
		expandCollapse(linkedWorkItem,lnkInd){
			let _self=this;
			for(var i in _self.data.linkedTickets)
				if(i!=lnkInd) _self.data.linkedTickets[i].show = false;
			linkedWorkItem.show=!linkedWorkItem.show;
		},
		setAppHeight:function(){
			let _self=this;
			if(!_self.data) return;
            var linkedTickets=_self.data.linkedTickets;
            var height=170;
			height += (linkedTickets && linkedTickets.length > 0) ? (linkedTickets.length * 85 + 230) : 75;
			if (_self.data && _self.data.userInfo && _self.data.userInfo.allowRelations == 1) {
				height += 20;
			}
			//client.instance.resize({ height: `${height}px` });
			client.invoke('resize', {  height: `${height}px`})
        },
	},
	components:{customIndexRenderer}
}

